module.exports = __webpack_public_path__ + "static/media/league-manager-logo-header.263eac0c.png";